import React, {Fragment} from "react";
import PropTypes from "prop-types";
import {Button} from "reactstrap";
import "./CommonHeader.scss";

const CommonHeader = (props) => {
  const {
    content,
    handleAddClick = () => {},
    handleSecondClick = () => {},
    secondContent,
    secondTestID = "second_button",
    showFirstButton = true,
    showSecondButton = false,
    testID = "first_button",
  } = props;

  return (
    <Fragment>
      <div className="common-header-container">
        {content && showFirstButton && (
          <span className="first-button">
            <Button
              data-cy={testID}
              className="btn_common roboto-bold"
              onClick={handleAddClick}
              style={{zIndex: "10"}}
            >
              {content.toUpperCase()}
            </Button>
          </span>
        )}
        {showSecondButton && secondContent && (
          <span className="second-button">
            <Button
              data-cy={secondTestID}
              className="btn_common roboto-bold"
              onClick={handleSecondClick}
              style={{zIndex: "10"}}
            >
              {secondContent.toUpperCase()}
            </Button>
          </span>
        )}
      </div>
    </Fragment>
  );
};

CommonHeader.propTypes = {
  /** Wether to show first button */
  showFirstButton: PropTypes.bool,
  /** Text to be displayed on first header button */
  content: PropTypes.string.isRequired,
  /** Callback function which will be executed when clicked on first header button */
  handleAddClick: PropTypes.func,
  /** testID which will be passed as data-cy attribute on first header button */
  testID: PropTypes.string,
  /** Wether to show second button */
  showSecondButton: PropTypes.bool,
  /** Text to be displayed on second header button */
  secondContent: PropTypes.string,
  /** Callback function which will be executed when clicked on second header button */
  handleSecondClick: PropTypes.func,
  /** testID which will be passed as data-cy attribute on second header button */
  secondTestID: PropTypes.string,
};

export default CommonHeader;
